import React, { useEffect, useState } from "react";
import {
  EmptyListPage,
  ErrorSuccessModal,
  TableHeader,
  TableLoader,
} from "../../../components/commons";
import { SearchIcon } from "../../../components/Icon";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { SCHEDULING_APPROVAL_PENDING_LIST_HEADERS } from "../../../constant/tableHeadersConstants/schedulingConstants/schedulingListTableHeaders";
import ScrollToTop from "../../../components/commons/ScrollToTop";
import InfiniteLoader from "../../../components/commons/InfiniteLoader/InfiniteLoader";
import {
  getSchedulingEmployeeApprovedListAction,
  getSchedulingReEstimateListAction,
  resetReEstimateDataList,
  resetSchedulingApproveTotalCount,
  resetSchedulingApprovedListing,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
} from "../../../redux/scheduling";
import useDebounce from "../../../customHooks/useDebounce";
import { resetSession } from "../../../redux/auth";
import ApprovedListFilter from "../../../components/Scheduling/UserView/ApprovedListFilter";
import SchedulingApprovalPendingListTable from "../../../components/Scheduling/UserView/SchedulingApprovalPendingListTable";
import ApprovalPendingJobModal from "./ApprovalPendingJobModal";
import UserViewListSorting from "../../../components/Scheduling/UserView/UserViewListSorting";
import {
  GetRequestIdPayloadType,
  GetSchedulingUserPayloadType,
} from "../../../commonTypes/schedulingTypes";
import { EmployeeListType } from "../../../redux/scheduling/schedulingTypes";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import InternalUsersDropdown from "../../../components/commons/InternalUsersDropdown/InternalUsersDropdown";

type AppProps = {
  fetching: boolean;
  employeeList: EmployeeListType[];
  token: string | null;
  totalCount: number;
  success: number | null;
  error: null | string;
  statusCode: number | null;
  message: string | null;
  type?: string;
  loginData: LoginResponseType;
  dispatchGetSchedulingEmployeeListAction: (
    data: GetSchedulingUserPayloadType
  ) => void;
  dispatchResetSchedulingList: () => void;
  dispatchResetSession: () => void;
  dispatchResetUserViewError: () => void;
  dispatchResetUserViewSuccess: () => void;
  dispatchResetUserViewMessage: () => void;
  dispatchResetUserViewStatusCode: () => void;
  dispatchResetTotalCount: () => void;
  dispatchResetRequestDataList: () => void;
  dispatchGetRequestListAction: (data: GetRequestIdPayloadType) => void;
};
const ApprovalPendingList = ({
  fetching,
  employeeList,
  token,
  success,
  error,
  statusCode,
  message,
  totalCount,
  type,
  loginData,
  dispatchResetRequestDataList,
  dispatchResetSession,
  dispatchGetSchedulingEmployeeListAction,
  dispatchResetSchedulingList,
  dispatchResetTotalCount,
  dispatchGetRequestListAction,
  dispatchResetUserViewError,
  dispatchResetUserViewMessage,
  dispatchResetUserViewStatusCode,
  dispatchResetUserViewSuccess,
}: AppProps) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [data, setData] = useState<EmployeeListType[]>([]);
  const [
    showSchedulingApprovalPendingModal,
    setShowSchedulingApprovalPendingModal,
  ] = useState<boolean>(false);
  const [
    showSchedulingApprovalPendingModalData,
    setShowSchedulingApprovalPendingModalData,
  ] = useState(null);
  const [selectedClient, setSelectedClient] = useState<string>("");
  const [jobTypeId, setJobTypeId] = useState("");
  const [searchData, setSearchData] = useState("");
  const [clearSearch, setClearSearch] = useState<boolean>(false);
  const [allSortingValue, setAllSortingValue] = useState("");
  const [sortByStartDate, setSortByStartDate] = useState({
    sort_by: "",
    sort_by_value: "",
  });
  const [filterelected, setFilterelected] = useState<string[]>([]);
  const [targetStartDate, setTargetStartDate] = useState("");
  const [targetEndDate, setTargetEndDate] = useState("");
  const [startDate, setStartDate] = useState("");
  const [startDateTo, setStartDateTo] = useState("");
  const [showData, setShowData] = useState(false);
  const [internalUserSelected, setInternalUserSelected] = useState<any>({
    value: null,
    label: "Select...",
  });
  const [clearFilterData, setClearFilterData] = useState(false);

  useEffect(() => {
    dispatchResetSchedulingList();
    dispatchResetTotalCount();
    dispatchResetUserViewError();
    dispatchResetUserViewMessage();
    dispatchResetUserViewStatusCode();
    dispatchResetUserViewSuccess();
  }, []);
  const handleToggleViewModal = () => {
    setShowSchedulingApprovalPendingModal(!showSchedulingApprovalPendingModal);
  };

  useEffect(() => {
    if (token) {
      let finalData: GetSchedulingUserPayloadType = {
        token,
        limit,
        offset,
        isApproved: 2,
        sortByStartDate,
        searchData,
        filterTargetStartDate: targetStartDate,
        filterTargetEndDate: targetEndDate,
        filterStartDate: startDate,
        filterStartDateTo: startDateTo,
        userId: internalUserSelected?.value,
      };

      if (offset < +totalCount) {
        dispatchGetSchedulingEmployeeListAction(finalData);
      } else if (offset === 0 && totalCount === 0) {
        dispatchGetSchedulingEmployeeListAction(finalData);
      }
    }
  }, [offset]);

  useEffect(() => {
    if (sortByStartDate) {
      if (offset != 0) {
        setOffset(0);
      } else {
        let finalData = {
          token,
          searchData,
          limit,
          offset,
          sortByStartDate,
          isApproved: 2,
          filterTargetStartDate: targetStartDate,
          filterTargetEndDate: targetEndDate,
          filterStartDate: startDate,
          filterStartDateTo: startDateTo,
          userId: internalUserSelected?.value,
        };

        if (token) {
          dispatchResetSchedulingList();
          dispatchGetSchedulingEmployeeListAction(finalData);
        }
      }
    }
  }, [sortByStartDate?.sort_by, sortByStartDate?.sort_by_value]);

  useEffect(() => {
    if (employeeList?.length === 0) {
      setData(employeeList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...employeeList]);
    } else {
      setData(employeeList);
    }
  }, [employeeList]);

  useDebounce(
    () => {
      if (searchData) {
        fetchNewData();
      }
    },
    500,
    [searchData]
  );

  const fetchNewData = () => {
    if (token) {
      setClearSearch(true);
      let finalData = {
        token,
        limit,
        searchData,
        offset,
        sortByStartDate,
        isApproved: 2,
        filterTargetStartDate: targetStartDate,
        filterTargetEndDate: targetEndDate,
        filterStartDate: startDate,
        filterStartDateTo: startDateTo,
        userId: internalUserSelected?.value,
      };
      if (offset === 0) {
        dispatchResetSchedulingList();
        dispatchGetSchedulingEmployeeListAction(finalData);
        setOffset(0);
      } else {
        setOffset(0);
      }
    }
  };

  const applyFilter = (data: any) => {
    setFilterelected([
      data?.targetStartDate,
      data?.targetEndDate,
      data?.startDate,
      data?.startDateTo,
    ]);
    let finalData = {
      token,
      limit,
      offset,
      searchData,
      sortByStartDate,
      isApproved: 2,
      filterTargetStartDate: data?.targetStartDate,
      filterTargetEndDate: data?.targetEndDate,
      filterStartDate: data?.startDate,
      filterStartDateTo: data?.startDateTo,
      userId: internalUserSelected?.value,
    };
    if (
      token &&
      (data?.targetStartDate ||
        data?.targetEndDate ||
        data?.startDate ||
        data?.startDateTo)
    ) {
      setOffset(0);
      dispatchResetSchedulingList();
      dispatchGetSchedulingEmployeeListAction(finalData);
    }
  };

  const clearFilter = () => {
    setTargetStartDate("");
    setTargetEndDate("");
    setStartDate("");
    setStartDateTo("");
    setFilterelected([]);
    setOffset(0);
    let finalData = {
      token,
      limit,
      offset: 0,
      searchData,
      sortByStartDate,
      isApproved: 2,
      userId: internalUserSelected?.value,
    };
    if (token) {
      dispatchResetSchedulingList();
      dispatchGetSchedulingEmployeeListAction(finalData);
    }
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);
    if (value?.length === 0) {
      let finalData = {
        token,
        limit,
        offset: 0,
        sortByStartDate,
        filterTargetStartDate: targetStartDate,
        filterTargetEndDate: targetEndDate,
        filterStartDate: startDate,
        filterStartDateTo: startDateTo,
        isApproved: 2,
        userId: internalUserSelected?.value,
      };
      dispatchGetSchedulingEmployeeListAction(finalData);
    }
  };

  const handleView = (data: any) => {
    dispatchResetRequestDataList();

    setShowSchedulingApprovalPendingModalData(data);
    setShowSchedulingApprovalPendingModal(!showSchedulingApprovalPendingModal);
    setJobTypeId(data?.job_id);
    if (data?.schedule_status === 1) {
      let finaData = {
        token,
        id: data?.req_id,
      };

      dispatchGetRequestListAction(finaData);
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [employeeList]);
  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < +totalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (employeeList?.length > 0) {
          if (!fetching && offset < +totalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetUserViewError();
            }}
          />
        );
      }
    }
    return false;
  };

  const handleSubmit = () => {
    setClearFilterData(!clearFilterData);
    clearFilter();
    setSearchData("");
    setTargetStartDate("");
    setTargetEndDate("");
    setStartDate("");
    setStartDateTo("");
    setFilterelected([]);
    setAllSortingValue("default");
    setSortByStartDate({
      sort_by: "",
      sort_by_value: "",
    });
    setShowData(true);
    setData([]);
    dispatchResetSchedulingList();
    setOffset(0);
    let finalData = {
      token,
      limit,
      offset: 0,
      isApproved: 2,
      userId: internalUserSelected?.value,
    };
    if (token && internalUserSelected?.value) {
      dispatchGetSchedulingEmployeeListAction(finalData);
    }
  };

  return (
    <div className="row">
      <div className="col-md-12 ">
        <div
          className="new-table-card"
          style={{ borderTopRightRadius: "0px", borderTopLeftRadius: "0px" }}
        >
          <div className="header">
            <div className="left-header">
              <div className="heading mb-2"> Approval Pending List</div>
              {!showData && type?.length ? (
                <></>
              ) : (
                <div className="sub-heading mt-0">{`Total ${
                  totalCount ? totalCount : 0
                } records found`}</div>
              )}
            </div>
            <div className="right-header " style={{ marginRight: "-32px" }}>
              <div className="col-md-7 position-relative ">
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={handleSearch}
                  style={{ paddingLeft: "35px" }}
                  value={searchData}
                />
              </div>
              <div className=" mr-1">
                <ApprovedListFilter
                  applyFilter={applyFilter}
                  targetStartDate={targetStartDate}
                  setTargetStartDate={setTargetStartDate}
                  targetEndDate={targetEndDate}
                  setTargetEndDate={setTargetEndDate}
                  clearFilter={clearFilter}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  startDateTo={startDateTo}
                  setStartDateTo={setStartDateTo}
                  filterelected={filterelected}
                  selectedClient={selectedClient}
                  internalUserSelected={internalUserSelected}
                  clearFilterData={clearFilterData}
                />
              </div>
              <div className="mr-5">
                <UserViewListSorting
                  setSortByStartDate={setSortByStartDate}
                  allSortingValue={allSortingValue}
                  setAllSortingValue={setAllSortingValue}
                />
              </div>
            </div>
          </div>
          {type?.length && (
            <div className="d-flex">
              <div className="col-md-3 p-0 mt-2 mb-4 ml-3">
                <InternalUsersDropdown
                  internalUserSelected={internalUserSelected}
                  setInternalUserSelected={setInternalUserSelected}
                />
              </div>
              <div className="col-md-3 d-flex align-items-center">
                <button
                  className="btn btn-primary pl-3 pb-2"
                  style={{ marginTop: "11px" }}
                  disabled={!internalUserSelected?.value}
                  onClick={handleSubmit}
                >
                  Apply
                </button>
              </div>
            </div>
          )}
          {!showData && type?.length ? (
            <div className="mt-5">
              <EmptyListPage
                title="No Approval Pending List Found!"
                text="Please Select User To See Approval Pending Scheduling!"
                imageWidth="30%"
              />
            </div>
          ) : (
            <>
              {fetching && offset === 0 ? (
                <TableLoader Rows={10} ColumnPerRow={7} />
              ) : employeeList?.length > 0 ? (
                <div className="jobsType" style={{ overflow: "auto" }}>
                  <table className="table table-bordered thead-light">
                    <thead className="text-start sticky-table-header-without-zindex">
                      <TableHeader
                        tableHeader={SCHEDULING_APPROVAL_PENDING_LIST_HEADERS}
                      />
                    </thead>
                    <tbody>
                      <SchedulingApprovalPendingListTable
                        handleToggleViewModal={handleToggleViewModal}
                        handleView={handleView}
                        schedulingUserViewListing={data}
                        tableHeader={SCHEDULING_APPROVAL_PENDING_LIST_HEADERS}
                        type="approvalPendingReport"
                      />
                      {fetching && offset > 0 && (
                        <div>{<InfiniteLoader />}</div>
                      )}
                      <div style={{ display: fetching ? "none" : "inline" }}>
                        <ScrollToTop />
                      </div>
                    </tbody>
                  </table>
                </div>
              ) : (
                fetching === false &&
                employeeList?.length === 0 && (
                  <div className="mt-5">
                    <EmptyListPage
                      title="No Approval Pending List Found!"
                      imageWidth="30%"
                    />
                  </div>
                )
              )}
            </>
          )}
        </div>
      </div>
      {handleErrorModal()}
      {showSchedulingApprovalPendingModal && (
        <ApprovalPendingJobModal
          modal={showSchedulingApprovalPendingModal}
          toggleModal={handleToggleViewModal}
          showSchedulingApprovalPendingModal={
            showSchedulingApprovalPendingModal
          }
          showSchedulingApprovalPendingModalData={
            showSchedulingApprovalPendingModalData
          }
        />
      )}
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  clientList: state.auth.assignedClientsToUserList,
  fetching: state.scheduling.fetching,
  success: state.scheduling.success,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  message: state.scheduling.message,
  employeeList: state.scheduling.employeeApprovedList,
  totalCount: state.scheduling.employeeAprrovedTotalCount,
  loginData: state.auth.loginData,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchGetSchedulingEmployeeListAction: (
    data: GetSchedulingUserPayloadType
  ) => dispatch(getSchedulingEmployeeApprovedListAction(data)),
  dispatchGetRequestListAction: (data: GetRequestIdPayloadType) =>
    dispatch(getSchedulingReEstimateListAction(data)),
  dispatchResetTotalCount: () => dispatch(resetSchedulingApproveTotalCount()),
  dispatchResetRequestDataList: () => dispatch(resetReEstimateDataList()),
  dispatchResetUserViewSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetUserViewError: () => dispatch(resetSchedulingError()),
  dispatchResetUserViewMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetUserViewStatusCode: () => dispatch(resetSchedulingStatusCode()),
  dispatchResetSchedulingList: () => dispatch(resetSchedulingApprovedListing()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ApprovalPendingList);
